module.exports = __webpack_public_path__ + "static/media/Tanzania.bea076ac.png";